module.exports = __webpack_public_path__ + "img/34.3cc880a1.png";